import { QueryResult } from 'react-query';
import { callApi, Controller, getApiUrl, useApi, UseApiOptions } from './useApi';

export interface ArtikelAttachment {
    artikelNr: string;
    datum: string;
    text: string;
    file: string;
    sendWithAngebot: boolean;
    oneDriveUrl: string | null;
    updDat?: string;
    updUhr?: number;
    updUser?: string;
}

export interface ArtikelAttachmentFilter {
    artikelNr?: number;
    maxRows?: number;
}

export function useArtikelAttachmentList(
    filter: ArtikelAttachmentFilter,
    apiOptions?: UseApiOptions<ArtikelAttachment[]>,
): QueryResult<ArtikelAttachment[]> {
    return useApi<ArtikelAttachment[]>(Controller.artikelAttachment + '/list', { filter }, apiOptions);
}

export async function uploadArtikelAttachment(file: File, artikelAttachment: ArtikelAttachment): Promise<boolean> {
    const data = new FormData();
    data.append('file', file);
    data.append('artikelAttachment.artikelNr', artikelAttachment.artikelNr.toString());
    data.append('artikelAttachment.text', artikelAttachment.text || '');
    data.append('artikelAttachment.datum', artikelAttachment.datum);
    data.append('artikelAttachment.sendwithangebot', artikelAttachment.sendWithAngebot ? 'true' : 'false');

    const request: RequestInit = {
        method: 'post',
        mode: 'cors',
        credentials: 'include',
        headers: {},
        body: data,
    };

    const result = await fetch(getApiUrl(Controller.artikelAttachment + '/upload'), request);
    return result.status === 200;
}

export async function updateArtikelAttachment(artikelAttachment: ArtikelAttachment): Promise<void> {
    return callApi<void>(Controller.artikelAttachment + '/update', { artikelAttachment });
}

export async function deleteArtikelAttachment(artikelAttachment: ArtikelAttachment): Promise<void> {
    return callApi<void>(Controller.artikelAttachment + '/delete', { artikelAttachment });
}
